import classNames from "classnames";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router";

import { APP_ENV } from "config/globals";
import CSSModules from "lib/utils/css-modules";
import { SelectCompanyDropdown, StLogo, Dropdown, Input, st } from "lib/index";
import { changeCurrentCompany } from "modules/auth";
import { pushRoute } from "modules/app/actions";
import styles from "./LeftBar.less";

window.st = st;
const navLinks = [
  {
    id: "dashboard",
    label: () => I18n.t("papp.app.LeftBar.dashboard"),
    icon: <i className="icon material-icons">home</i>,
  },
  {
    id: "calendar",
    label: () => I18n.t("papp.app.LeftBar.calendar"),
    icon: <i className="icon material-icons">date_range</i>,
    when: () => {
      return st.authorize.company.biz_type === "hotel"
        ? st.authorize.company.agent
        : st.authorize.company.agent || st.authorize.company.supplier || st.authorize.company.reseller;
    },
  },
  {
    id: "accommodation",
    label: () => I18n.t("papp.app.LeftBar.accommodation"),
    icon: <i className="icon material-icons">hotel</i>,
    when: () => {
      return st.authorize.company.biz_type === "hotel" && st.authorize.company.supplier;
    },
  },
  {
    id: "orders",
    label: () => I18n.t("papp.app.LeftBar.orders"),
    icon: <i className="icon material-icons">shopping_cart</i>,
    when: () => st.authorize.company.agent || st.authorize.company.supplier || st.authorize.company.reseller,
  },
  {
    id: "products",
    label: () => I18n.t("papp.app.LeftBar.products"),
    icon: <i className="icon material-icons">view_list</i>,
    when: () => st.authorize.company.agent || st.authorize.company.supplier || st.authorize.company.reseller,
  },
  {
    id: "customers",
    label: () => I18n.t("papp.app.LeftBar.customers"),
    icon: <i className="icon material-icons">people</i>,
    when: () => st.authorize.company.agent || st.authorize.company.supplier,
  },
  {
    id: "suppliers",
    label: () => I18n.t("papp.app.LeftBar.suppliers"),
    icon: <i className="icon material-icons">account_balance</i>,
    when: () => st.authorize.company.agent && st.authorize.member.role !== "company_employee",
  },
  {
    id: "agents",
    label: () => I18n.t("papp.app.LeftBar.agents"),
    icon: <i className="icon material-icons">share</i>,
    when: () => st.authorize.company.supplier && st.authorize.member.role !== "company_employee",
  },
  {
    id: "finances",
    label: () => I18n.t("papp.app.LeftBar.finances"),
    icon: <i className="icon material-icons">attach_money</i>,
    when: () =>
      (st.authorize.company.agent || st.authorize.company.supplier) && st.authorize.member.role !== "company_employee",
  },
  {
    id: "affiliate",
    label: () => I18n.t("papp.app.LeftBar.affiliate"),
    icon: <i className="icon material-icons">transfer_within_a_station</i>,
    when: () => st.authorize.company.affiliate && st.authorize.member.role !== "company_employee",
  },
  {
    id: "reviews",
    label: () => I18n.t("papp.app.LeftBar.reviews"),
    icon: <i className="icon material-icons">chat</i>,
    when: () =>
      st.authorize.company.supplier || st.authorize.member.role === "global_admin" || st.authorize.company.reseller,
  },
  {
    id: "widgets",
    label: () => I18n.t("papp.settings.SettingsLayout.widgets_settings"),
    icon: <i className="icon material-icons">compare_arrows</i>,
    when: () =>
      (st.authorize.company.affiliate || st.authorize.company.reseller) &&
      st.authorize.member.role !== "company_employee",
  },
  {
    id: "settings",
    label: () => I18n.t("papp.app.LeftBar.settings"),
    icon: <i className="icon material-icons">settings</i>
  }
];

const LeftBarNavLink = ({ path, active, icon, label }) => {
  return (
    <li>
      <Link to={path} className={classNames(styles["nav-link"], { active })}>
        <div className={styles["nav-link-icon"]}>{icon}</div>
        <div className={styles["nav-link-label"]}>{label}</div>
      </Link>
    </li>
  );
};

const LeftBarCompanyLabel = ({ company, link = false }) =>
  link ? (
    <Link className={styles["company-label"]} to={`/c/${company.id}/settings/company/account`}>
      <img src={st.getAttachmentImageUrl(company, "logo_image", "thumb")} />
      <span className={styles["company-label-name"]}>{company.name}</span>
    </Link>
  ) : (
    <span className={styles["company-label"]}>
      <img src={st.getAttachmentImageUrl(company, "logo_image", "thumb")} />
      <span className={styles["company-label-name"]}>{company.name}</span>
    </span>
  );

@connect(
  (state) => {
    const companies = (state.auth.user && state.auth.user.companies) || [];
    const currentCompanyId = state.auth.companyId;
    return {
      companies,
      currentCompany: state.auth.company.model || companies.find((c) => c.id === currentCompanyId),
      currentCompanyId,
      extended: state.app.leftBarExtended,
    };
  },
  (dispatch) =>
    bindActionCreators(
      {
        changeCurrentCompany,
        pushRoute,
      },
      dispatch
    )
)
@withRouter
@CSSModules(styles)
export default class LeftBar extends React.PureComponent {
  render() {
    const { currentCompany, currentCompanyId, companies, extended, changeCurrentCompany, pushRoute } = this.props;
    const links = navLinks.map((link) => {
      let path = `/c/${currentCompanyId}/${link.id}`;

      if (link.id === "dashboard") {
        path = `/c/${currentCompanyId}`;
      }
      if (link.id === "widgets") {
        path = `/c/${currentCompanyId}/settings/integrations/widgets?query`;
      }
      const active = this.props.router.isActive(path, link.id === "dashboard");
      return {
        ...link,
        path,
        active
      };
    });

    const companyLabel = <LeftBarCompanyLabel company={currentCompany} />;

    const onCurrentCompanyChange = (nextCompany) => {
      if (currentCompanyId !== nextCompany.id) {
        pushRoute(`/c/${nextCompany.id}`);
        window.location.reload();
      }
    };

    const renderLogo = () => {
      {
        if (
          st.authorize.member &&
          (st.authorize.member.role === "global_admin" ||
            st.authorize.member.role === "main_admin" ||
            st.authorize.member.role === "editor_admin")
        ) {
          return (
            <div styleName="section-logo">
              <Link to={`/c/100/orders`}>
                <StLogo black styleName="logo" />
              </Link>
            </div>
          );
        } else {
          return (
            <div styleName="section-logo">
              <Link to={`/c/${currentCompanyId}`}>
                <StLogo black styleName="logo" />
              </Link>
            </div>
          );
        }
      }
    };

    return (
      <div styleName={extended ? "container-extended" : "container-normal"}>
        {renderLogo()}

        <div styleName="section-company">
          {companies.length <= 1 && companyLabel}

          {companies.length > 1 && (
            <SelectCompanyDropdown
              trigger={companyLabel}
              companies={companies}
              value={currentCompany}
              onChange={onCurrentCompanyChange}
            />
          )}
        </div>

        {st.authorize.company && (
          <div className="section-nav">
            <ul styleName="nav">
              {links.map(
                (link) =>
                 (!link.when || link.when()) && (
                    <LeftBarNavLink
                      key={link.id}
                      path={link.path}
                      active={link.active}
                      icon={link.icon}
                      label={link.label()}
                    />
                  )
                  )}
            </ul>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/LeftBar.jsx